export default __webpack_public_path__ + "static/home3-660f4dd130a78a23cea87c4851cf4b2b.jpg";